import useNavbarStore from '../../context/useNavbarStore';
// import MesLogo from '../../images/getsitelogo.png';
import LoretteLogo from '../../images/loretteLogo.png';
import LoretteLogoWhite from '../../images/loretteLogoWhite.png';
import { MdOutlineRouter , MdSensors } from "react-icons/md";
import { FaChartBar } from "react-icons/fa";
import { BiLogOut } from "react-icons/bi";
// import { MdKeyboardArrowDown } from "react-icons/md";
import useUserToken from '../../context/userTokenContext';
import useNavbarSearchStore from '../../context/useNavBarSearchStore';
import useLocationsStore from '../../context/locationsStore';
import useThemeStore from "../../context/themeContext";

function SideBar() {
  const { isOpen, toggleOffcanvas } = useNavbarStore();

  const setUserToken = useUserToken((state) => state.setUserToken);
  const { searchList, clearSearchList } = useNavbarSearchStore();
  const { clearLocations } = useLocationsStore();
  const { currentTheme } = useThemeStore();

  const appVersion  = process.env.REACT_APP_VERSION;

  const logout = () => {
    setUserToken(null);
    clearSearchList();
    clearLocations();
    localStorage.removeItem('token');
    window.location.href = '/';
  }

  return (
    <>
      {/* Offcanvas Sidebar */}
      <div
        className={`fixed top-0 left-0 w-64 bg-[var(--gradientFirst)] h-full shadow-lg transform ${isOpen ? 'translate-x-0' : '-translate-x-full'
          } transition-transform duration-300 z-[9999] flex flex-col justify-between`}
        id="offcanvasNavbar"
      >
        {/* Upper Content */}
        <div>
          <div className="p-4 flex justify-between items-center">
            <h3 className="text-xl font-bold"></h3>
            <button onClick={toggleOffcanvas} className="text-xl font-bold bg-[var(--gradientFirst)] text-[var(--textPrimary)]">
              ✕
            </button>
          </div>
          <div className="flex items-center justify-center">
            {currentTheme === "light" ? (
              <img src={LoretteLogo} className='scale-75 shadow-lg shadow-black rounded-full' />
            ) : (
              <img src={LoretteLogoWhite} className='scale-75 shadow-lg shadow-white rounded-full' />
            )
            }
          </div>


          {/* Divider */}
          <div className='w-full flex justify-center mt-6 mb-2'>
            <hr className='w-[80%] h-[2px] self-center bg-[var(--textPrimary)]'></hr>
          </div>

          {/* Sidebar Content */}
          <div className="p-4 max-h-screen overflow-auto">
            <div className='flex flex-col gap-4 pb-10 text-lg font-bold text-[var(--textPrimary)]'>

              {/* Dashboard Option */}
              <a href="/dashboard" className='grid grid-cols-[1fr_2fr] hover:bg-[var(--hoverbg)] hover:text-white hover:underline rounded-lg'>
                <div className='flex flex-row justify-center items-center gap-6'>
                  <FaChartBar className='inline-block text-xl' />
                </div>
                <h1 className='text-start'>
                  Dashboard
                </h1>
              </a>

              {/* Gateways Option */}
              <a href="/gatewaysTable" className='grid grid-cols-[1fr_2fr] hover:bg-[var(--hoverbg)] hover:text-white hover:underline rounded-lg'>
                <div className='flex flex-row justify-center items-center gap-6'>
                  <MdOutlineRouter className='inline-block text-2xl' />
                </div>
                <h1 className='text-start'>
                  Gateways
                </h1>
              </a>

              {/* Devices Option */}
              <a href="/devicesTable" className='grid grid-cols-[1fr_2fr] hover:bg-[var(--hoverbg)] hover:text-white hover:underline rounded-lg '>
                <div className='flex flex-row justify-center items-center gap-6'>
                  <MdSensors className='inline-block text-2xl' />
                </div>
                <h1 className='text-start'>
                  Devices
                </h1>
              </a>


            </div>
          </div>
        </div>

        {/* Footer */}
        <div className='pb-4'>

          {/* Logout Option */}
          <div
            onClick={logout}
            className="px-4"
          >
            <div className='w-full grid grid-cols-[1fr_2fr] cursor-pointer text-xl font-bold text-[var(--textPrimary)] gap-6 hover:bg-[var(--hoverbg)] hover:text-white hover:underline rounded-lg'>
              <div className="mb-1">
                <BiLogOut className="inline-block text-2xl" />
              </div>
              <h1 className="text-start">
                Logout
              </h1>
            </div>
          </div>

          {/* Divider */}
          <div className='w-full flex justify-center mt-6 mb-4'>
            <hr className='w-[80%] h-[2px] self-center bg-[var(--textPrimary)]'></hr>
          </div>

          {/* Copyrights */}
          <div className='text-center text-sm text-[var(--textPrimary)] mt-4'>
          <p>© {new Date().getFullYear()} Mesogeos Digital S.A.</p>
          <p>v_{appVersion}</p>
          </div>


        </div>
      </div>

      {/* Overlay to close the offcanvas when clicking outside */}
      {isOpen && (
        <div
          onClick={toggleOffcanvas}
          className="fixed inset-0 bg-black opacity-50 z-40"
        />
      )}
    </>
  );
}

export default SideBar;